"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _EngagementAssociationsSelectsV = _interopRequireDefault(require("crm_ui/engagementAssociations/components/EngagementAssociationsSelectsV2"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var EngagementAssociationActions = _interopRequireWildcard(require("crm_ui/engagementAssociations/actions/EngagementAssociationActions"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var wrapperStyles = {
  position: 'absolute',
  right: '16px',
  zIndex: 1
};
var propTypes = {
  BETPortalAssociations: _propTypes.default.instanceOf(_immutable.List),
  BETServiceAssociations: _propTypes.default.instanceOf(_immutable.List),
  associationsMap: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  defaultAssociations: _reactImmutableProptypes.default.map,
  descriptor: _propTypes.default.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  engagementType: _propTypes.default.string,
  inTimeline: _propTypes.default.bool,
  localInteraction: _propTypes.default.object,
  objectType: _ProfileObjectTypesType.default.isRequired,
  objectTypesToAssociate: _propTypes.default.array,
  onAddBETAssociation: _propTypes.default.func,
  onCancel: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired,
  onRemoveBETAssociation: _propTypes.default.func,
  onSetBETAssociations: _propTypes.default.func,
  subject: _propTypes.default.object,
  subjectId: _propTypes.default.string.isRequired,
  gates: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired
  })
};

function InteractionWithAssociations(InteractionComponent) {
  function renderAssociationSelect(props) {
    return _react.default.createElement("div", {
      style: wrapperStyles,
      className: "m-top-2"
    }, _react.default.createElement(_EngagementAssociationsSelectsV.default, {
      associationsMap: props.associations,
      className: "p-top-2 p-left-1",
      handleSelect: props.handleSelect,
      handleRemove: props.handleRemove,
      inTimeline: props.inTimeline,
      subjectId: props.subjectId,
      objectType: props.objectType,
      objectTypesToAssociate: props.objectTypesToAssociate,
      subject: props.subject,
      engagement: props.engagement,
      engagementType: props.engagementType,
      onAddBETAssociation: props.onAddBETAssociation,
      onRemoveBETAssociation: props.onRemoveBETAssociation,
      onSetBETAssociations: props.onSetBETAssociations,
      BETPortalAssociations: props.BETPortalAssociations,
      BETServiceAssociations: props.BETServiceAssociations
    }));
  }

  var InteractionWithAssociationsComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(InteractionWithAssociationsComponent, _Component);

    function InteractionWithAssociationsComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithAssociationsComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithAssociationsComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(InteractionWithAssociationsComponent, [{
      key: "handleUpdateAssociation",
      value: function handleUpdateAssociation(associatedObjectType, associatedSubjectIds) {
        EngagementAssociationActions.addAssociations(this.props.objectType, Number(this.props.subjectId), associatedObjectType, associatedSubjectIds);
      }
    }, {
      key: "handleRemoveAssociation",
      value: function handleRemoveAssociation(associatedObjectType, associatedSubjectIds) {
        EngagementAssociationActions.removeAssociation(this.props.objectType, Number(this.props.subjectId), associatedObjectType, associatedSubjectIds);
      }
    }, {
      key: "handleCancel",
      value: function handleCancel() {
        this.props.onCancel();
      }
    }, {
      key: "handleGetSaveTooltip",
      value: function handleGetSaveTooltip() {
        var associationsMap = this.props.associationsMap;
        var hasAssociations = associationsMap.valueSeq().reduce(function (total, associatedObjects) {
          return associatedObjects.size + total;
        }, 0);

        if (!hasAssociations && this.props.descriptor && this.props.descriptor.type) {
          return {
            placement: 'bottom',
            title: _I18n.default.text('customerDataCommunicator.InteractionWithTimelineEngagement.noAssociationsTooltip', {
              engagementType: _I18n.default.text("customerDataCommunicator.engagementType." + this.props.descriptor.type)
            })
          };
        }

        return null;
      }
    }, {
      key: "handleSave",
      value: function handleSave(interactionRecord, engagement, options) {
        this.props.associationsMap.forEach(function (idsToAdd, objectTypeKey) {
          interactionRecord = interactionRecord.updateIn(['associations', objectTypeKey], function () {
            var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
            return ids.concat(idsToAdd);
          });
        });
        return this.props.onSave(interactionRecord, engagement, options);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          associations: this.props.associationsMap,
          onCancel: this.handleCancel,
          onSave: this.handleSave,
          saveTooltip: this.handleGetSaveTooltip(),
          onRemoveAssociation: this.handleRemoveAssociation,
          onUpdateAssociation: this.handleUpdateAssociation,
          renderTray: renderAssociationSelect.bind(this, (0, _extends2.default)({}, this.props, {
            handleRemove: this.handleRemoveAssociation,
            handleSelect: this.handleUpdateAssociation
          }))
        }));
      }
    }]);
    return InteractionWithAssociationsComponent;
  }(_react.Component);

  InteractionWithAssociationsComponent.propTypes = propTypes;
  return InteractionWithAssociationsComponent;
}

var _default = InteractionWithAssociations;
exports.default = _default;
module.exports = exports.default;